/* eslint-disable class-methods-use-this */
/* eslint-disable no-useless-constructor */
import React, { useState, useEffect, useRef } from 'react';
import { CSSProperties } from 'react';
import ReactEchart from 'echarts-for-react';
import * as echarts from 'echarts';
import moment from 'moment';
import { getSettings } from 'api/sagas';

import { toHslaString } from 'shared/mappers';
import { setEChartsRef } from 'shared/echartsRef';
import { useDispatch } from 'react-redux';

export interface VisualMapProps {
    controlId: number;
    displayEndDateTime?: moment.Moment;
    displayStartDateTime?: moment.Moment;
    getSettings: (controlId: number) => void;
    map?: EchartsMapOptions;
    titleOptions?: TitleOptions;
    options?: echarts.EChartOption & any;
    overrideDisplayDate?: boolean;
}

const VisualMap: React.FC<VisualMapProps> = (props) => {
    const [echartsRegistered, setEchartsRegistered] = useState(false);
    const echartRef = useRef(null);
    const dispatch: any = useDispatch()

    useEffect(() => {
        if (props.map !== undefined && !echartsRegistered) {
            echarts.registerMap(props.map.kind, props.map.geoJson, props.map.specialAreas);
            setEchartsRegistered(true);
        }
    }, [props.map, echartsRegistered]);
    useEffect(() => {
        dispatch(getSettings(props.controlId))
    }, [props.controlId])

    const getMapHeight = (controlId: number, map: EchartsMapOptions, options: any) => {
        const container = document.querySelectorAll(`[data-cid="${controlId}"][class="scoreboards-render-root"]`)[0] as HTMLElement;
        const containerWidth = container.offsetWidth;
        let mapHeight = 0;
        if (!options.visualMap[0].show) {
            mapHeight = containerWidth * map.aspectRatio;
        } else {
            mapHeight = containerWidth * map.aspectRatio;
            if (containerWidth > 650 && containerWidth <= 750) {
                mapHeight = containerWidth * map.aspectRatio * 2;
            } else if (containerWidth > 550 && containerWidth <= 650) {
                mapHeight = containerWidth * map.aspectRatio * 2.5;
            } else if (containerWidth > 350 && containerWidth <= 550) {
                mapHeight = containerWidth * map.aspectRatio * 3;
            } else if (containerWidth > 150 && containerWidth <= 350) {
                mapHeight = containerWidth * map.aspectRatio * 3.5;
            }
        }
        return mapHeight;
    };

    const getTextStyle = (options: TitleStyleOptions): CSSProperties => {
        return {
            textAlign: 'center',
            fontSize: `${options.size}px`,
            color: toHslaString(options.color),
            fontStyle: options.italic ? 'italic' : 'normal',
            fontWeight: options.bold ? 'bold' : 'normal',
        };
    };

    const isModuleDisplayDateActive = (now: moment.Moment) => {
        const nowIsAfterStartTime = now.isAfter(props.displayStartDateTime);
        const nowIsBeforeEndTime = !props.displayEndDateTime || now.isBefore(props.displayEndDateTime);
        return nowIsAfterStartTime && nowIsBeforeEndTime;
    };

    const shouldShowModule = () =>
        echartsRegistered && (props.overrideDisplayDate || isModuleDisplayDateActive(moment()));

    return (
        <div>
            {props.titleOptions && shouldShowModule() && (
                <h2 style={getTextStyle(props.titleOptions.titleStyle)}>{props.titleOptions.titleText}</h2>
            )}
            {props.titleOptions && props.titleOptions.subTitleText && props.titleOptions.subTitleStyle && shouldShowModule() && (
                <h3 style={getTextStyle(props.titleOptions.subTitleStyle)}>{props.titleOptions.subTitleText}</h3>
            )}
            {props.map && props.options && shouldShowModule() && (
                <div className="echartsMapWrapper" style={{ width: '100%' }}>
                    <ReactEchart
                        ref={(e: any) => {
                            setEChartsRef(props.controlId, e);
                            echartRef.current = e;
                        }}
                        option={props.options}
                        style={{ height: getMapHeight(props.controlId, props.map, props.options) }}
                    />
                </div>
            )}
        </div>
    );
};

VisualMap.defaultProps = {
    overrideDisplayDate: false,
};

export default VisualMap;